export class MarkerHelper {
  public static getCircleMarkerSvg(radius: number, weight: number, foregroundColor: string, backgroundColor: string, opacity: number = 1): { svg: string; width: number; height: number } {
    const style = `stroke:${foregroundColor};stroke-width:3;fill:${backgroundColor};fill-opacity:1;opacity:${opacity};`;
    const r = radius;
    const w = weight;
    const s = r + w;
    const s2 = s * 2;
    return {
      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}"><circle r="${r}" style="${style}" /></svg>`,
      width: s2,
      height: s2,
    };
  }
}
